module.exports = __webpack_public_path__ + "img/product-preview-68.b3193b1.png";